import { createSlice } from "@reduxjs/toolkit";
import { getMaterailReqList } from "../../reduxApi/admin/MaterialReqReduxApi";


const MaterialReqSlice = createSlice({
    name: 'materialRequest',
    initialState: {
        status: 'idel',
        isFiltered: false,
        materialRequest: [],
    },
    reducers: {
        setFilteredStatus: (state, action) => {
            state.isFiltered = action.payload;
        },
        deleteMaterialRequestAction: (state, action) => {
            action.payload.forEach((id) => {
                const index = state.materialRequest.findIndex((item) => item.ROWID === id);
                if (index !== -1) {
                    state.materialRequest.splice(index, 1);
                }
            });
        },

        updateMaterialRequestAction: (state, action) => {
             const { ROWID, payload } = action.payload;
            const index = state.materialRequest.findIndex((item) => item.ROWID === action.payload.ROWID);

            if (index !== -1) {
                state.materialRequest[index] = {
                    ...state.materialRequest[index],
                    ...payload
                };
            }
        },
        
        addMaterialRequestAction: (state, action) => {
            console.log("action--->", action.payload);
            const temp = action.payload;
            console.log("temp", temp);
            temp.ROWID = action.payload.ROWID;
            console.log("temp.ROWID", temp.ROWID);
            state.materialRequest.unshift({ materialRequest: temp }); // add new data at beginning of array
        }
    },
    extraReducers: (builder) => {
        builder.addCase(getMaterailReqList.pending, (state, action) => {
            state.status = 'pending';
        })
        .addCase(getMaterailReqList.fulfilled, (state, action) => {
            state.status = 'fulfilled';
            state.materialRequest = action.payload?.data || action.payload;
        })
        .addCase(getMaterailReqList.rejected, (state, action) => {
            state.status = 'rejected';
        });
    }
});

export const { 
    deleteMaterialRequestAction, 
    updateMaterialRequestAction, 
    addMaterialRequestAction, 
    setFilteredStatus 
} = MaterialReqSlice.actions;

export default MaterialReqSlice.reducer;